export class ShowFarmsByIdFarmUseCase{
  constructor(farmsDapRepository) {
    this.farmsDapRepository=farmsDapRepository
  }
  async execute(ID_FARM) {
    const resp=await this.farmsDapRepository.showFarmsByIdFarmUseCase(ID_FARM)
    return resp

  }
}
